/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
//
// THIS IS A GENERATED FILE
// DO NOT MODIFY IT! YOUR CHANGES WILL BE LOST
import { Inject, Injectable, Optional } from '@angular/core';
import {
  GrpcCallType,
  GrpcClient,
  GrpcClientFactory,
  GrpcEvent,
  GrpcMetadata
} from '@ngx-grpc/common';
import {
  GRPC_CLIENT_FACTORY,
  GrpcHandler,
  takeMessages,
  throwStatusErrors
} from '@ngx-grpc/core';
import { Observable } from 'rxjs';
import * as thisProto from './prebook.pb';
import * as tenGrpcBooking_serviceDto000 from '../../../services/booking-service/dto/booking-service-common.pb';
import * as booking_platformV1Shared001 from '../../../external/mercury/v1/shared/price-details.pb';
import * as booking_platformV1Shared002 from '../../../external/mercury/v1/shared/cancellation-policy.pb';
import * as booking_platformV1Shared003 from '../../../external/mercury/v1/shared/contact-info.pb';
import * as booking_platformV1Shared004 from '../../../external/mercury/v1/shared/payment-session.pb';
import * as booking_platformV1Shared005 from '../../../external/mercury/v1/shared/checkout-list-item.pb';
import * as booking_platformV1Shared006 from '../../../external/mercury/v1/shared/booking-question-answer.pb';
import * as booking_platformV1Shared007 from '../../../external/mercury/v1/shared/booking-question-validation-error.pb';
import * as booking_platformV1Shared008 from '../../../external/mercury/v1/shared/request-property-validation-error.pb';
import * as booking_platformV1Shared009 from '../../../external/mercury/v1/shared/booking-session-status.pb';
import * as googleProtobuf010 from '@ngx-grpc/well-known-types';
import * as googleType011 from '../../../external/mercury/v1/shared/google/type/decimal.pb';
import * as booking_platformV1Shared012 from '../../../external/mercury/v1/shared/booking-component-detail.pb';
import * as booking_platformV1Shared013 from '../../../external/mercury/v1/shared/booking-status.pb';
import * as booking_platformV1Shared014 from '../../../external/mercury/v1/shared/customer-cancellation-reason.pb';
import * as booking_platformV1Shared015 from '../../../external/mercury/v1/shared/cancellation-status.pb';
import * as booking_platformV1Shared016 from '../../../external/mercury/v1/shared/geolocation.pb';
import * as booking_platformV1Shared017 from '../../../external/mercury/v1/shared/auto-complete-result-item.pb';
import * as booking_platformV1Shared018 from '../../../external/mercury/v1/shared/seat.pb';
import * as booking_platformV1Shared019 from '../../../external/mercury/v1/shared/benefit-item.pb';
import * as googleProtobuf020 from '@ngx-grpc/well-known-types';
import * as googleProtobuf021 from '@ngx-grpc/well-known-types';
import * as tenGrpcBooking_serviceDto022 from '../../../services/booking-service/dto/mercury-hub-dining-prebook-request.pb';
import * as tenGrpcBooking_serviceDto023 from '../../../services/booking-service/dto/property-prebook-request.pb';
import * as tenGrpcBooking_serviceDto024 from '../../../services/booking-service/dto/property-prebook-response.pb';
import * as booking_platformV1025 from '../../../external/mercury/v1/booking-flow.pb';
import * as booking_platformV1Entertainment026 from '../../../external/mercury/v1/entertainment/entertainment.pb';
import * as booking_platformV1Dining027 from '../../../external/mercury/v1/dining/dining.pb';
import { GRPC_PREBOOK_CLIENT_SETTINGS } from './prebook.pbconf';
/**
 * Service client implementation for ten.grpc.booking_service.api.Prebook
 */
@Injectable({ providedIn: 'any' })
export class PrebookClient {
  private client: GrpcClient<any>;

  /**
   * Raw RPC implementation for each service client method.
   * The raw methods provide more control on the incoming data and events. E.g. they can be useful to read status `OK` metadata.
   * Attention: these methods do not throw errors when non-zero status codes are received.
   */
  $raw = {
    /**
     * Unary call: /ten.grpc.booking_service.api.Prebook/PropertyPrebook
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<tenGrpcBooking_serviceDto024.PropertyPrebookResponse>>
     */
    propertyPrebook: (
      requestData: tenGrpcBooking_serviceDto023.PropertyPrebookRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<
      GrpcEvent<tenGrpcBooking_serviceDto024.PropertyPrebookResponse>
    > => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/ten.grpc.booking_service.api.Prebook/PropertyPrebook',
        requestData,
        requestMetadata,
        requestClass: tenGrpcBooking_serviceDto023.PropertyPrebookRequest,
        responseClass: tenGrpcBooking_serviceDto024.PropertyPrebookResponse
      });
    },
    /**
     * Unary call: /ten.grpc.booking_service.api.Prebook/AttractionPrebook
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<booking_platformV1025.PreBookResponse>>
     */
    attractionPrebook: (
      requestData: booking_platformV1025.PreBookRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<booking_platformV1025.PreBookResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/ten.grpc.booking_service.api.Prebook/AttractionPrebook',
        requestData,
        requestMetadata,
        requestClass: booking_platformV1025.PreBookRequest,
        responseClass: booking_platformV1025.PreBookResponse
      });
    },
    /**
     * Unary call: /ten.grpc.booking_service.api.Prebook/AttractionCheckout
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<booking_platformV1025.CheckoutResponse>>
     */
    attractionCheckout: (
      requestData: booking_platformV1025.CheckoutRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<booking_platformV1025.CheckoutResponse>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/ten.grpc.booking_service.api.Prebook/AttractionCheckout',
        requestData,
        requestMetadata,
        requestClass: booking_platformV1025.CheckoutRequest,
        responseClass: booking_platformV1025.CheckoutResponse
      });
    },
    /**
     * Unary call: /ten.grpc.booking_service.api.Prebook/MHCancelReservation
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<booking_platformV1Entertainment026.CancelReservationResponse>>
     */
    mHCancelReservation: (
      requestData: booking_platformV1Entertainment026.CancelReservationRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<
      GrpcEvent<booking_platformV1Entertainment026.CancelReservationResponse>
    > => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/ten.grpc.booking_service.api.Prebook/MHCancelReservation',
        requestData,
        requestMetadata,
        requestClass:
          booking_platformV1Entertainment026.CancelReservationRequest,
        responseClass:
          booking_platformV1Entertainment026.CancelReservationResponse
      });
    },
    /**
     * Unary call: /ten.grpc.booking_service.api.Prebook/MHReserveTickets
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<booking_platformV1Entertainment026.ReserveTicketsResponse>>
     */
    mHReserveTickets: (
      requestData: booking_platformV1Entertainment026.ReserveTicketsRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<
      GrpcEvent<booking_platformV1Entertainment026.ReserveTicketsResponse>
    > => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/ten.grpc.booking_service.api.Prebook/MHReserveTickets',
        requestData,
        requestMetadata,
        requestClass: booking_platformV1Entertainment026.ReserveTicketsRequest,
        responseClass: booking_platformV1Entertainment026.ReserveTicketsResponse
      });
    },
    /**
     * Unary call: /ten.grpc.booking_service.api.Prebook/MHDiningPrebook
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<googleProtobuf021.Empty>>
     */
    mHDiningPrebook: (
      requestData: tenGrpcBooking_serviceDto022.MercuryHubDiningPrebookRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<GrpcEvent<googleProtobuf021.Empty>> => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/ten.grpc.booking_service.api.Prebook/MHDiningPrebook',
        requestData,
        requestMetadata,
        requestClass:
          tenGrpcBooking_serviceDto022.MercuryHubDiningPrebookRequest,
        responseClass: googleProtobuf021.Empty
      });
    },
    /**
     * Unary call: /ten.grpc.booking_service.api.Prebook/THReserveSlot
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<booking_platformV1Dining027.ReserveSlotResponse>>
     */
    tHReserveSlot: (
      requestData: booking_platformV1Dining027.ReserveSlotRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<
      GrpcEvent<booking_platformV1Dining027.ReserveSlotResponse>
    > => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/ten.grpc.booking_service.api.Prebook/THReserveSlot',
        requestData,
        requestMetadata,
        requestClass: booking_platformV1Dining027.ReserveSlotRequest,
        responseClass: booking_platformV1Dining027.ReserveSlotResponse
      });
    }
  };

  constructor(
    @Optional() @Inject(GRPC_PREBOOK_CLIENT_SETTINGS) settings: any,
    @Inject(GRPC_CLIENT_FACTORY) clientFactory: GrpcClientFactory<any>,
    private handler: GrpcHandler
  ) {
    this.client = clientFactory.createClient(
      'ten.grpc.booking_service.api.Prebook',
      settings
    );
  }

  /**
   * Unary call @/ten.grpc.booking_service.api.Prebook/PropertyPrebook
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<tenGrpcBooking_serviceDto024.PropertyPrebookResponse>
   */
  propertyPrebook(
    requestData: tenGrpcBooking_serviceDto023.PropertyPrebookRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<tenGrpcBooking_serviceDto024.PropertyPrebookResponse> {
    return this.$raw
      .propertyPrebook(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/ten.grpc.booking_service.api.Prebook/AttractionPrebook
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<booking_platformV1025.PreBookResponse>
   */
  attractionPrebook(
    requestData: booking_platformV1025.PreBookRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<booking_platformV1025.PreBookResponse> {
    return this.$raw
      .attractionPrebook(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/ten.grpc.booking_service.api.Prebook/AttractionCheckout
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<booking_platformV1025.CheckoutResponse>
   */
  attractionCheckout(
    requestData: booking_platformV1025.CheckoutRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<booking_platformV1025.CheckoutResponse> {
    return this.$raw
      .attractionCheckout(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/ten.grpc.booking_service.api.Prebook/MHCancelReservation
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<booking_platformV1Entertainment026.CancelReservationResponse>
   */
  mHCancelReservation(
    requestData: booking_platformV1Entertainment026.CancelReservationRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<booking_platformV1Entertainment026.CancelReservationResponse> {
    return this.$raw
      .mHCancelReservation(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/ten.grpc.booking_service.api.Prebook/MHReserveTickets
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<booking_platformV1Entertainment026.ReserveTicketsResponse>
   */
  mHReserveTickets(
    requestData: booking_platformV1Entertainment026.ReserveTicketsRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<booking_platformV1Entertainment026.ReserveTicketsResponse> {
    return this.$raw
      .mHReserveTickets(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/ten.grpc.booking_service.api.Prebook/MHDiningPrebook
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<googleProtobuf021.Empty>
   */
  mHDiningPrebook(
    requestData: tenGrpcBooking_serviceDto022.MercuryHubDiningPrebookRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<googleProtobuf021.Empty> {
    return this.$raw
      .mHDiningPrebook(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/ten.grpc.booking_service.api.Prebook/THReserveSlot
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<booking_platformV1Dining027.ReserveSlotResponse>
   */
  tHReserveSlot(
    requestData: booking_platformV1Dining027.ReserveSlotRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<booking_platformV1Dining027.ReserveSlotResponse> {
    return this.$raw
      .tHReserveSlot(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }
}
